export default __webpack_public_path__ + "static/media/04.1c1ec1a4.webp";